import { render, staticRenderFns } from "./UserInterface.vue?vue&type=template&id=b53cb782&scoped=true"
import script from "./UserInterface.vue?vue&type=script&lang=js"
export * from "./UserInterface.vue?vue&type=script&lang=js"
import style0 from "./UserInterface.vue?vue&type=style&index=0&id=b53cb782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53cb782",
  null
  
)

export default component.exports